module.exports = __webpack_public_path__ + "static/img/H2.313ee873.png";